<template>
  <div class="login-home">
    <div class="head">
      <div class="nav">
        <div class="container">
          <div class="nav-row">
            <el-image
              class="logo"
              :src="require('@/assets/images/simulation/logo_doudian.svg')"
              fit="cover"
            ></el-image>
            <div class="nav-menu">
              <div
                class="menu-item"
                :class="{ active: activeMenu == item.text }"
                v-for="(item, idx) in menuList"
                :key="idx"
              >
                <a
                  :href="item.link"
                  :target="idx == 0 ? '' : '_blank'"
                  rel="noopener noreferrer"
                  >{{ item.text }}</a
                >
              </div>
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link menu-item">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="https://www.douyin.com/"
                    >抖音官网</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="https://www.oceanengine.com/?source=doudia"
                    >巨量引擎</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="https://fuwu.jinritemai.com/optimus/60dc30bd05420d0040d2f289"
                    >基地服务</el-dropdown-item
                  >
                  <el-dropdown-item command="https://op.jinritemai.com/home"
                    >开放平台</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="https://fuwu.jinritemai.com/?from=fxg_home_more"
                    >服务市场</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="banner">
        <el-carousel height="620px" arrow="never">
          <el-carousel-item>
            <el-image
              style="height: 100%"
              :src="require('@/assets/images/simulation/banner_doudian.png')"
              fit="cover"
            ></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="login-box">
        <div class="box-head">
          <h2 class="title">入驻抖店</h2>
          <el-form
            :model="params"
            :rules="rules"
            ref="ruleForm"
            class="login-form"
          >
            <el-form-item prop="mobile">
              <el-input
                class="input"
                v-model="params.mobile"
                placeholder="手机号码"
                maxlength="11"
              ></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input
                class="input"
                v-model="params.code"
                placeholder="验证码"
                maxlength="4"
              >
                <span slot="suffix" @click="params.code = 'yyds'"
                  >发送验证码</span
                >
              </el-input>
            </el-form-item>
            <el-button type="primary" class="s-btn" @click="handleLogin"
              >立即入驻</el-button
            >
          </el-form>
        </div>
        <div class="login-link">已有账号？<span>立即登录</span></div>
        <div class="other-login">
          <div class="o-title">
            <span>其他入驻方式</span>
          </div>
          <div class="others">
            <div class="o-item">
              <el-image
                class="o-icon"
                src="data:image/svg+xml;base64,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"
                fit="cover"
              ></el-image>
              <p class="o-text">抖音入驻</p>
            </div>
            <div class="o-item">
              <el-image
                class="o-icon"
                src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzJweCIgaGVpZ2h0PSIzMnB4IiB2aWV3Qm94PSIwIDAgMzIgMzIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU5ICg4NjEyNykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+57yW57uEIDU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz4KICAgICAgICA8Y2lyY2xlIGlkPSJwYXRoLTEiIGN4PSIxNiIgY3k9IjE2IiByPSIxNiI+PC9jaXJjbGU+CiAgICAgICAgPGNpcmNsZSBpZD0icGF0aC0zIiBjeD0iMTYiIGN5PSIxNiIgcj0iMTUuNSI+PC9jaXJjbGU+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0i6aG16Z2iLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSLmiYvmnLrnmbvlvZXlpIfku70tMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEzMDguMDAwMDAwLCAtNDU0LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0i57yW57uELTE5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTQ4LjAwMDAwMCwgMTA2LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC0xNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzIuMDAwMDAwLCAzNDAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9IuiSmeeJiOWkh+S7vSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTI4LjAwMDAwMCwgOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPG1hc2sgaWQ9Im1hc2stMiIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGF0aC0xIj48L3VzZT4KICAgICAgICAgICAgICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICAgICAgICAgICAgICA8dXNlIGlkPSLokpnniYgiIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiNwYXRoLTEiPjwvdXNlPgogICAgICAgICAgICAgICAgICAgICAgICA8bWFzayBpZD0ibWFzay00IiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwYXRoLTMiPjwvdXNlPgogICAgICAgICAgICAgICAgICAgICAgICA8L21hc2s+CiAgICAgICAgICAgICAgICAgICAgICAgIDx1c2UgZmlsbD0iI0ZGRkZGRiIgeGxpbms6aHJlZj0iI3BhdGgtMyI+PC91c2U+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSLnvJbnu4QiIG1hc2s9InVybCgjbWFzay00KSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgNS42Nzc0MTkpIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iRmlsbC0xIiBmaWxsPSIjRkYzNzNDIiBwb2ludHM9IjMxLjk5OTU4NzEgLTAuMDAwMTAzMjI1ODA2IC0wLjAwMDQxMjkwMzIyNiAxLjY3MjE1NDg0IC0wLjAwMDQxMjkwMzIyNiAyMC42MTgyMTk0IDMxLjk5OTU4NzEgMTguOTQ1OTYxMyI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJGaWxsLTIiIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iOC43MTk1ODcxIDcuMDE4MjE5MzUgOC43MTk1ODcxIDUuMDgyNzM1NDggNC4zNDI4MTI5IDQuNjg1MzE2MTMgNC4zNDI4MTI5IDYuNjIxODMyMjYiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iRmlsbC0zIiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjQuMzQyNTAzMjMgNy45NjE3MDMyMyA0LjM0MjUwMzIzIDkuODk3MTg3MSA4LjcxOTI3NzQyIDEwLjI5NDYwNjUgOC43MTkyNzc0MiA4LjM1ODA5MDMyIj48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtNCIgZmlsbD0iI0ZGRkZGRiIgcG9pbnRzPSIxNS41NTgyOTY4IDEzLjAxMjY0NTIgMy4yMDAxMDMyMyAxMy42NTc4MDY1IDMuMjAwMTAzMjMgMTEuOTIzNjEyOSAxNS41NTgyOTY4IDExLjI3ODQ1MTYiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iRmlsbC01IiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjI4Ljc4NTAzMjMgMTIuMzIxMTM1NSAxNi40MjY4Mzg3IDEyLjk2NzMyOSAxNi40MjY4Mzg3IDExLjIzMjEwMzIgMjguNzg1MDMyMyAxMC41ODY5NDE5Ij48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtNiIgZmlsbD0iI0ZGRkZGRiIgcG9pbnRzPSIyOC4wOTg1ODA2IDUuMTc4NTI5MDMgMTkuMTA3NjEyOSA1LjY0OTIzODcxIDE5LjEwNzYxMjkgMy45MTQwMTI5IDI4LjA5ODU4MDYgMy40NDQzMzU0OCI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSLnvJbnu4QiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy4wOTY3NzQsIDMuMDY5NTIzKSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik05LjA0MDEwMzIzLDAuNzc1MzI5MDMyIEw3LjA3MTU4NzEsMC44Nzg1NTQ4MzkgQzcuMDE5OTc0MTksNC43OTE4NDUxNiA2Ljk2NjI5Njc3LDYuOTk1NzE2MTMgNi4yNjAyMzIyNiw4LjU3NDAzODcxIEM1LjU0MTc4MDY1LDEwLjE3NDAzODcgNC4wMTUwNzA5NywxMS40OTg0MjU4IDAuOTcxOTc0MTk0LDE0LjEzNzkwOTcgQzAuODQ2MDM4NzEsMTQuMjQ3MzI5IDAuNzE0OTQxOTM1LDE0LjM2MDg3NzQgMC41ODA3NDgzODcsMTQuNDc3NTIyNiBMMy42ODE2NTE2MSwxNC4zMTU0NTgxIEM4LjczMTQ1ODA2LDkuODU4MTY3NzQgOC45MzA2ODM4Nyw4Ljg4ODg3NzQyIDkuMDQwMTAzMjMsMC43NzUzMjkwMzIiIGlkPSJGaWxsLTciIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtOSIgZmlsbD0iI0ZGRkZGRiIgcG9pbnRzPSIxMC41NTEyMjU4IDEwLjkxMDM0ODQgOC4xNzYgMTEuMDM0MjE5NCAxMC4wODQ2NDUyIDEzLjk4MDI4MzkgMTIuNDU5ODcxIDEzLjg1NjQxMjkiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMTEiIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iMjMuNzk1MiAxMC4yMTc4MDY1IDIxLjQxOTk3NDIgMTAuMzQyNzA5NyAyMy4zMjg2MTk0IDEzLjI4ODc3NDIgMjUuNzAzODQ1MiAxMy4xNjM4NzEiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMTMiIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iMTcuNjIxNzgwNiAxMC41NDAzODcxIDE1LjI0NjU1NDggMTAuNjY1MjkwMyAxMy4zMzg5NDE5IDEzLjgxMDU4MDYgMTUuNzEyMTAzMiAxMy42ODY3MDk3Ij48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJGaWxsLTE1IiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjIwLjUwMTc4MDYgMTMuNDM2MDc3NCAxOC40ODc4NDUyIDEzLjU0MTM2NzcgMTguNDg3ODQ1MiA2LjkwNzA0NTE2IDIwLjUwMTc4MDYgNi44MDE3NTQ4NCI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjMuMTkxMzI5LDAuNDY5MzY3NzQyIEwyMy4xOTEzMjksMS42ODY0IEMyMi4wNDQ0OTAzLDIuNjY5MTA5NjggMTkuNzMwMTY3Nyw0LjMzNjIwNjQ1IDEzLjMzMDE2NzcsNS43NDQyMDY0NSBMMTMuMzMwMTY3Nyw3LjU5NTA0NTE2IEMyMS4xMDUxMzU1LDUuOTI0ODUxNjEgMjMuNzU0OTQxOSwzLjU3MjMzNTQ4IDI1LjAwMTkwOTcsMi4zOTI0NjQ1MiBMMjUuMDAxOTA5NywwLjM3NDQgTDIzLjE5MTMyOSwwLjQ2OTM2Nzc0MiBaIiBpZD0iRmlsbC0xNyIgZmlsbD0iI0ZGRkZGRiI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTUuNTk0NTI5LDEuOTU1NzE2MTMgQzE1LjUwODg1MTYsMS44OTY4Nzc0MiAxNS40MjczMDMyLDEuODQxMTM1NDggMTUuMzQ5ODgzOSwxLjc4ODQ5MDMyIEwxMy42NzU1NjEzLDIuODgxNjUxNjEgQzEzLjY3NTU2MTMsMi44ODE2NTE2MSAxNC40MjE4ODM5LDMuNDIyNTU0ODQgMTQuNTAyNCwzLjQ3OTMyOTAzIEMxNS44NzIyMDY1LDQuNDIwNzQ4MzkgMTguMzcwMjcxLDYuMTM5NDU4MDYgMjUuNjg3OTQ4NCw2Ljk0OTc4MDY1IEwyNS42ODc5NDg0LDUuMDk4OTQxOTQgQzE5LjA0MTIzODcsNC4zMjY4MTI5IDE2LjgxOTgxOTQsMi43OTkwNzA5NyAxNS41OTQ1MjksMS45NTU3MTYxMyIgaWQ9IkZpbGwtMTkiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMjEiIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iMTMuNjc1MTQ4NCAyLjg4MTY1MTYxIDE1LjM2ODA1MTYgMy45MDE1MjI1OCAxNy40MDQ2OTY4IDAuNzcxNzE2MTI5IDE1LjU0MzUzNTUgMC4wMDE2NTE2MTI5Ij48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="
                fit="cover"
              ></el-image>
              <p class="o-text">头条入驻</p>
            </div>
            <div class="o-item">
              <el-image
                class="o-icon"
                src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzJweCIgaGVpZ2h0PSIzMnB4IiB2aWV3Qm94PSIwIDAgMzIgMzIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU5ICg4NjEyNykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+57uEIDEyIOaLt+i0nTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPgogICAgICAgIDxjaXJjbGUgaWQ9InBhdGgtMSIgY3g9IjE2IiBjeT0iMTYiIHI9IjE2Ij48L2NpcmNsZT4KICAgICAgICA8bGluZWFyR3JhZGllbnQgeDE9IjAuODc1JSIgeTE9IjEwMC4xMjUxMTclIiB4Mj0iMTAwLjgxMjUlIiB5Mj0iMC4wOTM4Mzc5NzMxJSIgaWQ9ImxpbmVhckdyYWRpZW50LTMiPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjRkY2NjAwIiBvZmZzZXQ9IjE2JSI+PC9zdG9wPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjRkYwMDNDIiBvZmZzZXQ9Ijg0JSI+PC9zdG9wPgogICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgPHBhdGggZD0iTTAsMTEuMjgyIEMwLjAyNSw3LjA5IDIuNjY2LDQuOTc2IDUuMTMsMy4wMDUgTDUuMTMsMy4wMDUgQzQuODUxLDIuMzQgNC42OTQsMS42MzEgNC42NjcsMC45MTEgTDQuNjY3LDAuOTExIEMxLjcxMiwzLjU1MiAwLjAxNyw3LjMyMiAwLDExLjI4MiIgaWQ9InBhdGgtNCI+PC9wYXRoPgogICAgICAgIDxsaW5lYXJHcmFkaWVudCB4MT0iNTAuMDAxNzAxOCUiIHkxPSIwLjAwNjQ4NDUxNzMlIiB4Mj0iNTAuMDAxNzAxOCUiIHkyPSIxMDAuMDAwMjI4JSIgaWQ9ImxpbmVhckdyYWRpZW50LTYiPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjRkZGRkZGIiBvZmZzZXQ9IjAlIj48L3N0b3A+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNGRkZGRkYiIG9mZnNldD0iMTAwJSI+PC9zdG9wPgogICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgPHBhdGggZD0iTTEuMTI0LDEuMDcxIEM0LjU2NiwyLjM3OSA2LjI5Niw2LjIyOCA0Ljk4OSw5LjY2OSBMNC45ODksOS42NjkgQzUuODQ2LDkuMDk2IDYuNTI4LDguMzIxIDYuOTg3LDcuNDMgTDYuOTg3LDcuNDMgQzYuMTcsNC4yMDUgMy42NTksMS42ODcgMC40NDQsMC44NTQgTDAuNDQ0LDAuODU0IEMwLjY3NCwwLjkxNCAwLjkwMSwwLjk4NyAxLjEyNCwxLjA3MSBMMS4xMjQsMS4wNzEgWiIgaWQ9InBhdGgtNyI+PC9wYXRoPgogICAgICAgIDxsaW5lYXJHcmFkaWVudCB4MT0iNDkuOTk3NjUwNSUiIHkxPSIwLjAwMjIzNjI5MTY5JSIgeDI9IjQ5Ljk5NzY1MDUlIiB5Mj0iOTkuOTk4NDAxNCUiIGlkPSJsaW5lYXJHcmFkaWVudC05Ij4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0ZGRkZGRiIgb2Zmc2V0PSIwJSI+PC9zdG9wPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjRkZGRkZGIiBzdG9wLW9wYWNpdHk9IjAuODA0ODc4NzE1IiBvZmZzZXQ9IjEwMCUiPjwvc3RvcD4KICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgIDxwb2x5Z29uIGlkPSJwYXRoLTEwIiBwb2ludHM9IjAgMC44MjQgMjEuMzE1NyAwLjgyNCAyMS4zMTU3IDI1Ljk5OTcgMCAyNS45OTk3Ij48L3BvbHlnb24+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0i6aG16Z2iLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSLmiYvmnLrnmbvlvZXlpIfku70tMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE0MjguMDAwMDAwLCAtNDU0LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0i57yW57uELTE5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTQ4LjAwMDAwMCwgMTA2LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC0xNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzIuMDAwMDAwLCAzNDAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC0xMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQwLjAwMDAwMCwgOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Iue7hC0xMi3mi7fotJ0iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDguMDAwMDAwLCAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC00Ij4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8bWFzayBpZD0ibWFzay0yIiBmaWxsPSJ3aGl0ZSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx1c2UgaWQ9IuiSmeeJiCIgZmlsbD0iI0Q4RDhEOCIgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Iui1hOa6kC0xIiBtYXNrPSJ1cmwoI21hc2stMikiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0i55+p5b2iIiBmaWxsPSJ1cmwoI2xpbmVhckdyYWRpZW50LTMpIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHg9IjAiIHk9IjAiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0i57yW57uEIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1LjAwMDAwMCwgMi4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCA0LjE3NTgwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxtYXNrIGlkPSJtYXNrLTUiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGF0aC00Ij48L3VzZT4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L21hc2s+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPGcgaWQ9IkNsaXAtMiI+PC9nPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLDExLjI4MiBDMC4wMjUsNy4wOSAyLjY2Niw0Ljk3NiA1LjEzLDMuMDA1IEw1LjEzLDMuMDA1IEM0Ljg1MSwyLjM0IDQuNjk0LDEuNjMxIDQuNjY3LDAuOTExIEw0LjY2NywwLjkxMSBDMS43MTIsMy41NTIgMC4wMTcsNy4zMjIgMCwxMS4yODIiIGlkPSJGaWxsLTEiIGZpbGw9InVybCgjbGluZWFyR3JhZGllbnQtNikiIG9wYWNpdHk9IjAuOTUiIG1hc2s9InVybCgjbWFzay01KSI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTUuMTMwMSw3LjE4MDEgQzQuODUxMSw2LjUxNjEgNC42OTQxLDUuODA3MSA0LjY2NzEsNS4wODcxIEM0Ljk2NzEsNS42NTgxIDUuMzQ4MSw2LjE4MjEgNS43OTYxLDYuNjQ0MSBDNS41NzcxLDYuODIzMSA1LjM1NDEsNy4wMDExIDUuMTMwMSw3LjE4MDEiIGlkPSJGaWxsLTMiIGZpbGw9IiNGRkZGRkYiIG9wYWNpdHk9IjAuOCI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOS4wMDAwMDAsIDAuMTc1ODAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPG1hc2sgaWQ9Im1hc2stOCIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwYXRoLTciPjwvdXNlPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iQ2xpcC02Ij48L2c+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTEuMTI0LDEuMDcxIEM0LjU2NiwyLjM3OSA2LjI5Niw2LjIyOCA0Ljk4OSw5LjY2OSBMNC45ODksOS42NjkgQzUuODQ2LDkuMDk2IDYuNTI4LDguMzIxIDYuOTg3LDcuNDMgTDYuOTg3LDcuNDMgQzYuMTcsNC4yMDUgMy42NTksMS42ODcgMC40NDQsMC44NTQgTDAuNDQ0LDAuODU0IEMwLjY3NCwwLjkxNCAwLjkwMSwwLjk4NyAxLjEyNCwxLjA3MSBMMS4xMjQsMS4wNzEgWiIgaWQ9IkZpbGwtNSIgZmlsbD0idXJsKCNsaW5lYXJHcmFkaWVudC05KSIgbWFzaz0idXJsKCNtYXNrLTgpIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMC4xNzU4MDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8bWFzayBpZD0ibWFzay0xMSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwYXRoLTEwIj48L3VzZT4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L21hc2s+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPGcgaWQ9IkNsaXAtOCI+PC9nPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNS4xODY3LDE1LjUwODcgQzE1LjA5OTcsMTUuMzU2NyAxNC45NzM3LDE1LjIzMDcgMTQuODIwNywxNS4xNDI3IEw4LjgyNTcsMTEuNjgxNyBDOC4zNDg3LDExLjQwNTcgNy43MzY3LDExLjU2OTcgNy40NjA3LDEyLjA0NzcgQzcuMzczNywxMi4xOTg3IDcuMzI3NywxMi4zNzE3IDcuMzI3NywxMi41NDY3IEw3LjMyNzcsMTkuNDY5NyBDNy4zMjc3LDIwLjAyMTcgNy43NzQ3LDIwLjQ2ODcgOC4zMjY3LDIwLjQ2ODcgQzguNTAxNywyMC40Njg3IDguNjczNywyMC40MjI3IDguODI1NywyMC4zMzQ3IEwxNC44MjA3LDE2Ljg3MzcgQzE1LjI5ODcsMTYuNTk3NyAxNS40NjI3LDE1Ljk4NjcgMTUuMTg2NywxNS41MDg3IE0xMy45ODg3LDkuNjY4NyBDMTUuNTg2Nyw4LjYwMDcgMTYuNTc1Nyw2LjgzMTcgMTYuNjQ4Nyw0LjkxMTcgQzE5LjYxODcsNy41NjU3IDIxLjMxNTcsMTEuMzU5NyAyMS4zMTU3LDE1LjM0MTcgQzIxLjMxNTcsMjEuMjI4NyAxNi41NDM3LDI1Ljk5OTcgMTAuNjU3NywyNS45OTk3IEM0Ljc3MTcsMjUuOTk5NyAtMC4wMDAzLDIxLjIyODcgLTAuMDAwMywxNS4zNDE3IEMtMC4wMDAzLDcuNDA5NyA5LjMyNTcsNi44Nzk3IDkuMzI1NywwLjgyMzcgQzkuNTk2NywwLjg4OTcgOS44NjM3LDAuOTcyNyAxMC4xMjQ3LDEuMDcwNyBDMTMuNTY1NywyLjM3ODcgMTUuMjk1Nyw2LjIyNzcgMTMuOTg4Nyw5LjY2ODciIGlkPSJGaWxsLTciIGZpbGw9IiNGRkZGRkYiIG1hc2s9InVybCgjbWFzay0xMSkiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
                fit="cover"
              ></el-image>
              <p class="o-text">火山入驻</p>
            </div>
          </div>
        </div>
        <div class="agreement">
          <p>
            登录即代表同意<a
              href="https://school.jinritemai.com/doudian/web/article/101699"
              target="_blank"
              rel="noopener noreferrer"
              >用户协议</a
            >和<a
              href="https://school.jinritemai.com/doudian/web/article/101700"
              target="_blank"
              rel="noopener noreferrer"
              >隐私协议</a
            >
          </p>
          <a
            href="https://fxg.jinritemai.com/login/unable"
            target="_blank"
            rel="noopener noreferrer"
            >无法登录？</a
          >
        </div>
      </div>
    </div>
    <div class="tips-container">
      <div class="tips-head">
        <div class="tab-item active">
          入驻流程
          <div class="active-icon-one"></div>
          <div class="active-icon-two"></div>
        </div>
        <div class="tab-item">入驻材料与费用</div>
        <div class="tab-item">常见问题</div>
      </div>
      <div class="tips-content">
        <div class="tips-box">
          <div class="tips-item" v-for="(item, idx) in tipsList" :key="idx">
            <el-image class="icon" :src="item.icon" fit="cover"></el-image>
            <h2 class="tips-title">{{ item.title }}</h2>
            <p class="tips-during">{{ item.during }}</p>
            <div class="tips-info">{{ item.info }}</div>
            <el-image
              class="arrow-icon"
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSA2Ljg2NjAzTDIuNSAxMC4zMzAxQzEuODMzMzMgMTAuNzE1IDEgMTAuMjMzOSAxIDkuNDY0MUwxIDIuNTM1OUMxIDEuNzY2MSAxLjgzMzMzIDEuMjg0OTcgMi41IDEuNjY5ODdMOC41IDUuMTMzOThDOS4xNjY2NyA1LjUxODg3IDkuMTY2NjcgNi40ODExMiA4LjUgNi44NjYwM1oiIGZpbGw9IndoaXRlIiBzdHJva2U9IiNFRUY1RkYiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K"
              fit="cover"
            ></el-image>
          </div>
        </div>
        <p class="more">
          还想了解更多细节？可前往<a
            href="https://school.jinritemai.com/doudian/web/article/109466?rank=1&fromPage=search_result&searchInfo=8775578399373535591%3A1%3A0&query=%E5%85%A5%E9%A9%BB%E6%B5%81%E7%A8%8B"
            target="_blank"
            rel="noopener noreferrer"
            >抖音电商学习中心</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeMenu: "首页",
      menuList: [
        { text: "首页", link: "#" },
        { text: "入驻流程", link: "https://fxg.jinritemai.com/enter" },
        {
          text: "入驻材料与费用",
          link: "https://fxg.jinritemai.com/enter/quali-fee",
        },
        { text: "热招品牌", link: "https://fxg.jinritemai.com/hot/brand" },
        { text: "热招经销商", link: "https://fxg.jinritemai.com/hot/dealer" },
        { text: "常见问题", link: "https://fxg.jinritemai.com/question" },
        {
          text: "电商学习中心",
          link: "https://school.jinritemai.com/doudian/web?from=shop_adtable",
        },
        {
          text: "下载抖店App",
          link: "https://im.jinritemai.com/pc_app_download?from=officialwebsite",
        },
      ],
      rules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, message: "请输入正确的手机号", trigger: "blur" },
        ],
        code: { required: true, message: "验证码", trigger: "blur" },
      },
      params: {
        mobile: "",
        code: "",
      },
      tipsList: [
        {
          icon: require("@/assets/images/simulation/icon_tips1.png"),
          title: "第一步.填写资质信息",
          during: "约30分钟",
          info: "登录后提交营业执照、法人/经营者身份证明、店铺LOGO等",
        },
        {
          icon: require("@/assets/images/simulation/icon_tips2.png"),
          title: "第二步. 平台审核",
          during: "约1~3工作日",
          info: "平台进行资质审核",
        },
        {
          icon: require("@/assets/images/simulation/icon_tips3.png"),
          title: "第三步. 账户验证",
          during: "约1~3个工作日",
          info: "对私银行卡号+银行预留手机号或对公账户打款验证",
        },
        {
          icon: require("@/assets/images/simulation/icon_tips4.png"),
          title: "第四步. 缴纳保证金",
          during: "约10分钟",
          info: "经营多类目时仅按最高金额收取，不叠加，完成后即可成功开店正常营业",
        },
      ],
    };
  },
  methods: {
    handleCommand(command) {
      window.open(command);
    },
    handleLogin() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$router.push(`/simulation/doudian?mobile=${this.params.mobile}`);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login-home {
  .head {
    position: relative;
    .nav {
      position: relative;
      display: flex;
      align-items: center;
      height: 60px;
      z-index: 99;
      .nav-row {
        display: flex;
        align-items: center;
        .logo {
          margin-right: 58px;
          cursor: pointer;
        }
        .nav-menu {
          display: flex;
          align-items: center;
          .menu-item {
            position: relative;
            line-height: 20px;
            margin: 0 20px;
            padding: 5px 2px;
            text-align: center;
            transition: color 0.3s;
            &:hover {
              font-weight: 600;
              color: #1966ff;
            }
            &.active {
              font-weight: 600;
              color: #1966ff;
              &::after {
                content: "";
                position: absolute;
                top: calc(100% - 1px);
                left: 50%;
                transform: translateX(-50%);
                display: block;
                height: 2px;
                width: 16px;
                background-color: #1966ff;
              }
            }
          }
          .el-dropdown-link {
            color: #333;
            cursor: pointer;
          }
        }
      }
    }
    .banner {
      margin-top: -60px;
    }
    .login-box {
      position: absolute;
      right: calc(50vw - 580px);
      top: 90px;
      display: inline-block;
      height: 452px;
      width: 352px;
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0 4px 8px 0 rgba(12, 40, 103, 10%);
      color: #444;
      overflow: hidden;
      z-index: 99;
      .box-head {
        margin-bottom: 8px;
        padding: 40px 32px 0;
        text-align: center;
        .title {
          margin-bottom: 8px;
          font-size: 20px;
          font-weight: 600;
          color: #333;
        }
        .login-form {
          margin-top: 24px;
          font-size: 16px;
          ::v-deep .input {
            .el-input__suffix {
              padding-right: 12px;
              color: #1966ff;
              line-height: 40px;
              cursor: pointer;
            }
          }
          .s-btn {
            margin-top: 8px;
            width: 100%;
            background: #1966ff;
            border-color: #1966ff;
          }
        }
      }
      .login-link {
        margin: 24px 0 26px;
        line-height: 20px;
        text-align: center;
        span {
          color: #1966ff;
          cursor: pointer;
        }
      }
      .other-login {
        padding: 0 32px;
        .o-title {
          padding-top: 5px;
          font-size: 12px;
          line-height: 16px;
          color: #85878c;
          text-align: center;
          span {
            padding: 0 12px;
          }
          &::before,
          &::after {
            width: 32%;
            border-bottom: 1px solid #eee;
            content: " ";
            display: inline-block;
            flex: 1 1;
            position: relative;
            top: -4px;
            &::before {
              left: 0;
            }
            &::after {
              right: 0;
            }
          }
        }
        .others {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 8px 8px 20px;
          .o-item {
            text-align: center;
            cursor: pointer;
            .o-icon {
              width: 24px;
              height: 24px;
            }
            .o-text {
              margin-top: 2px;
              color: #55585c;
              font-size: 12px;
              line-height: 16px;
            }
          }
        }
      }
      .agreement {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 0 32px;
        width: 100%;
        height: 48px;
        font-size: 12px;
        line-height: 16px;
        color: #aaabaf;
        background: rgba(243, 244, 246, 0.5);
        border-radius: 0 0 4px 4px;
        a {
          padding: 0 3px;
          color: #55585c;
        }
      }
    }
  }
  .tips-container {
    height: 487px;
    background: linear-gradient(0deg, #f2f6fe, rgba(242, 246, 254, 0) 60.32%);
    .tips-head {
      display: flex;
      justify-content: center;
      padding-top: 48px;
      .tab-item {
        position: relative;
        margin: 0 32px;
        color: #565960;
        font-size: 20px;
        line-height: 28px;
        user-select: none;
        cursor: pointer;
        &.active {
          color: #252931;
          &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: -3px;
            height: 8px;
            width: calc(100% + 6px);
            backdrop-filter: blur(7.33333px);
            background: linear-gradient(
                274.01deg,
                #05f -45.66%,
                #d6e3ff 101.62%
              ),
              #1966ff;
            border-radius: 4px;
            z-index: -1;
          }
          .active-icon-one {
            position: absolute;
            right: -22px;
            top: -12px;
            width: 15px;
            height: 15px;
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAEQklEQVRogd2aQVLbWBCGv342HsMm2kxKJBvlBAMnQJxgmBOMXAUeajaBE9icAGfnAaowJ8A3wJwAOEHEBlSZjVcklcTqWdg4xggjPQlCzb+01e/1r+73Xvf/BP8TSJGDOYE6lQq+KL4YXomypOBMTNZXpY8hlAEXCufRgfSKmDs3ESdQp1rmPYIvgp/ZAaU/EHoKR5/2pGvrhzWRt4EuDcpsieFP2zESEKqy8+Ub3X5H+lkMMxNxAnXmKzSAray2GRCqshPtSyetQSYir+u6VlYOVX7k/ZNC6ek3alFHwsceNWnHXKzrbgmOn40EgOBLhZPXdV17/NFH4ATqVOc4tlnIRUJjmtGB7Dz0/0wio/VwAiwV7pkFZpGZmVrVOY55ISQAxNB065q4Sz5IxK1r42enUxIEOr9u6L2Xm5ha7oYGIhw+vVvWCD9/ZXnyrLkXETdQT4TG8/qVGd4v5bs+3k+tMk3Aey6PbGEMW+66jlP/DhE3UK/gkmMI5VKUTCVHGkxmTvnOP8NoFIFTYrpaphu1757K7qb6JiZQWCFv5AXfXVc/OpDeeLG7gXpS4WOugSFUQy1qpyvN39S1qeRcj0rvel9Wf6TWXL6tVmKOPi+wnJYEwNWeNI2yDDxaSz08Mb4TqDOOyJu6nqnl4SfQvdqTP2x9cTfVMwPObOu4OGbbwDCtbEkA4c0CNUtbAKK2hHEJ6xdhBN8AmIp9GTKA7X4rWxOUhKgtPQHbDnHFAMS20VBO87Sn04gNH6wMBccAiNoRUUjdwaVB1JYegpUYYQDU8MrGeADnNnYzEXNhYzaMSMw7G+N/96VwImr5clK3ugmw3/tnoWQ3bh4iLwp5iHhOoIULEfLdbuO5XexWNVa1XHwbbHswm5H1peW8hbfCYlixsbvdtax2ChHeF5le7oYGWJb2w9QqW54HglMtFyedWrfYyrkBqH7h3LaDE0MjSdXICreuDSyjIWZEJOxIX+HU1omycOwGat3tuXVtCPbdaTzgaLz9aomW7UCAJxVORjmeGk6gzmJdd/OQAMLoQHpjIlFbejkFAk+EQ3dDD9NEx11Xf77CGTmvJ2RUZN4R6Ny6NiVvDz2CKj2FCxV6JqYfG5xSjKclfjMxa0Wp+mp4F7UlvEPEC9T5OsfHZ706yAEROlf/SA2mSpSwI30VHpTuXxjCeMLXRO138S89QV+egD0JVWqTV3OJRaMKtadQBouCCJ3p+8VEInlVjSdGeDPP9vSPD5bxI6HtnsFPRqiG1STVZmY/cr0nLeHFLP5QDavTWvItUl1PL9Z1C9gt1K1smEkCUnaI13vSyq3RWmJCU545d6YPBtxN9UxMU3mCO5QpiNJXZef6QFLVgFbforz9W5fi77TArpubBVH6CB9uFmhlkWJzfR3kbqpvBmyp8HueccCewNg+rwMwTDkG+AbWgJXUtZpyiaGrQjfLvUoS/gMOsIeGnIZUNgAAAABJRU5ErkJggg==);
            background-size: 100% 100%;
          }
          .active-icon-two {
            position: absolute;
            right: -29px;
            top: -9px;
            width: 15px;
            height: 15px;
            backdrop-filter: blur(2.3px);
            background: hsla(0, 0%, 87%, 0.2);
            border: 0.5px solid hsla(0, 0%, 5%, 0.04);
            border-radius: 50%;
          }
        }
      }
    }
    .tips-content {
      margin-top: 16px;
      margin-left: auto;
      margin-right: auto;
      width: 1068px;
      height: 355px;
      background-color: #fff;
      border-radius: 8px;
      overflow: auto;
      .tips-box {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        margin-top: 32px;
        min-height: 237px;
        .tips-item {
          flex: 1 1;
          font-size: 12px;
          line-height: 16px;
          padding: 0 27px;
          position: relative;
          text-align: center;
          .icon {
            border-radius: 50%;
            height: 102px;
            width: 102px;
          }
          .tips-title {
            margin-top: 16px;
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
            color: #252931;
          }
          .tips-during {
            display: inline-block;
            margin-top: 16px;
            padding: 2px 8px;
            background-color: #f9f9fa;
            border-radius: 10px;
            color: #85878c;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
          }
          .tips-info {
            margin-top: 8px;
            color: #898b8f;
          }
          .arrow-icon {
            position: absolute;
            right: -8px;
            top: 43px;
            width: 16px;
            height: 16px;
            background-color: #fff;
            z-index: 2;
          }
          &:last-child {
            .arrow-icon {
              display: none;
            }
          }
          &:not(:last-child) {
            &::after {
              content: "";
              position: absolute;
              left: 50%;
              top: 50px;
              transform: translateX(51px);
              display: block;
              width: calc(100% - 102px);
              border-top: 2px solid #eef5ff;
            }
          }
        }
      }
      .more {
        margin: 32px 0;
        color: #898b8f;
        font-size: 12px;
        text-align: center;
        a {
          color: #1966ff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>